'use client';

import React from 'react';
import { COMPANY } from '@/lib/company';
import { useI18n } from '@/i18n/LocaleProvider';

export default function ContactSection() {
  const { t } = useI18n();

  return (
    <section id="contact" className="pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto scroll-mt-32">
      <div className="glass-card rounded-3xl border border-border p-8 md:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <span className="text-xs font-bold tracking-widest uppercase text-accent mb-2 block">{t.contact.eyebrow}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground mb-3 leading-tight">
            {t.contact.title}
          </h2>
          <p className="text-muted-foreground leading-relaxed max-w-xl">
            {t.contact.body}
          </p>
        </div>
        <a
          href={`mailto:${COMPANY.email}`}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-bold bg-primary text-primary-foreground hover:bg-primary/90 transition-colors flex-shrink-0"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          {COMPANY.email}
        </a>
      </div>
    </section>
  );
}
